<template>
  <div class="home-class-style">
    <div class="home-swipe">
      <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
        <van-swipe-item v-for="(item,index) in swipeImg1" :key="index">
          <img :src="item.img" />
        </van-swipe-item>
      </van-swipe>
    </div>
    <div class="home-product home-article">
       <div class="home-nav2-bg">
        <ul class="home-nav2">
          <li
            v-for="(item,index) in liList2"
            :key="index"
            :class="isLink2==index ? 'li-style2 li-check-style2' : 'li-style2'"
            @click="chooseLi2(item,index)"
          >
            {{item.name}}
            <svg-icon v-if="isLink2==index" icon-class="home_line2"></svg-icon>
          </li>
        </ul>
       </div>
      <div class="home-article-nav">
        <div class="header-search" @click.prevent="checkInput">
          <div class="search-pla">请输入搜索的界面（例保险、健康、教育等）</div>
        </div>
        <ul>
          <li
            v-for="(item,index) in liList"
            :key="index"
            :class="isLink==index ? 'li-style li-check-style' : 'li-style'"
            @click="chooseLi(item,index)"
          >{{item.name}}</li>
        </ul>
      </div>

      <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
        <van-list
          :offset="1"
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="onLoad"
        >
          <div class="list-img">
            <div class="home-data-list" v-for="(item,index) in dataList " :key="index ">
              <!-- 文章 -->
              <div v-if="item.contentType=='ART'" class="home-list-sty">
                <div class="list-left">
                  <img :src="item.coverLink" alt />
                </div>
                <div class="list-right">
                  <div class="list-r-tit" @click="goToDetails(item.artcId,item.coverLink)">
                    <!-- <img src="./img/home_name0.png" alt /> -->
                    <svg-icon icon-class="home_name2"></svg-icon>
                    <span>{{item.title}}</span>
                  </div>
                  <div class="list-r-foot">
                    <span>阅读 {{item.viewCount || 0}} 次</span>
                    <span>转发 {{item.fwdCount || 0}} 次</span>
                  </div>
                </div>
              </div>
              <!-- 图文 -->
              <div v-if="item.contentType=='PAW'">
                <div class="list-r-tit">
                  <!-- <img src="./img/home_name1.png" alt /> -->
                  <svg-icon icon-class="home_name1"></svg-icon>
                  <span>{{item.artcSummary}}</span>
                </div>
                <div class="home-imgList-sty">
                  <!-- 图片大于一张 并且不是四张 -->
                  <div v-if="item!=4" class="home-isImg">
                    <div
                      v-for="(it,ind) in item.imgurl"
                      :key="ind"
                      :class="item > 1 && item!=4 ? 'home-img-size home-img-size2':'home-img-size'"
                    >
                      <div>
                        <van-image
                          @click="seeImg(item,$event)"
                          v-if="it"
                          width="100%"
                          height="100%"
                          :src="it"
                        />
                      </div>
                    </div>
                  </div>
                  <!-- 图片是四张 -->
                  <div v-if="item==4" class="home-isImg">
                    <div v-for="(it,ind) in item.imgurl" :key="ind" class="home-img-size4">
                      <div>
                        <van-image
                          @click="seeImg(item,$event)"
                          v-if="it"
                          width="100%"
                          height="100%"
                          :src="it"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div class="list-r-foot list-igm-foot">
                  <span>阅读 {{item.viewCount || 0}} 次</span>
                  <span>转发 {{item.fwdCount || 0}} 次</span>
                </div>
              </div>
              <!-- 视频 -->
              <div v-if="item.contentType=='VOD'">
                <div class="list-r-tit">
                  <!-- <img src="./img/home_name2.png" alt /> -->
                  <svg-icon icon-class="home_name3"></svg-icon>
                  <span>{{item.vtitle}}</span>
                </div>
                <div class="home-imgList-sty">
                  <div class="home-img-size">
                    <div>
                      <van-image
                        @click="goToVideo('inner',item.artcId)"
                        width="100%"
                        height="100%"
                        :src="item.faceImgUrl || item.imgUrl1"
                      />
                    </div>
                  </div>
                </div>
                <div class="list-r-foot list-igm-foot">
                  <span>阅读 {{item.viewCount || 0}}次</span>
                  <span>转发 {{item.fwdCount || 0}}次</span>
                </div>
              </div>
            </div>
          </div>
        </van-list>
      </van-pull-refresh>
      <!-- 推荐文章列表 -->
    </div>
    <div class="article_add" @click="goToPublish()">
      <svg-icon icon-class="article_add"></svg-icon>
    </div>
  </div>
</template>

<script>
import URL from "@/api/api";
import { Toast, Lazyload } from "vant";
export default {
  data() {
    return {
      value1:'',//搜索
      level1: '1',
      level2: '推荐',
      isLink: '0',
      isLink2: '0',
      loading: false,
      finished: false,
      refreshing: false,
      pageNum: 0, //页数
      size: 6,//总条数
      total: 0,
      swipeImg1: [
        { img: require('./img/a-banner.png') },
        { img: require('./img/a-banner.png') },
      ],
      liList: [
        { id: 1, name: '全部' },
        { id: 2, name: '文章' },
        { id: 3, name: '图文' },
        { id: 4, name: '视频' },
      ],
      liList2: [
        { id: 1, name: '推荐' },
        { id: 2, name: '贷款' },
        { id: 3, name: '保险' },
        { id: 4, name: '健康' },
        { id: 5, name: '教育' },
        { id: 6, name: '汽车' },
        { id: 7, name: '财经' },
        { id: 8, name: '生活' },
        { id: 9, name: '明星' },
      ],
      dataList: [

      ],
    }
  },
  mounted() {
    document.title = "文章"
    // this.getData()
  },
  methods: {
    // 搜索
    checkInput() {
      this.$router.push({
        path: '/search',
        query: { inputFocus: 1 }
      })
    },
    goToPublish() {
      this.$router.push({
        path: "/articleUpload"
      })
    },
    chooseLi(item, i) {
      this.isLink = i
      this.level1 = item.id
      this.pageNum = 0
      this.getData()
    },
    chooseLi2(item, i) {
      this.isLink2 = i
      this.level2 = item.name
      this.pageNum = 0
      this.getData()
    },
    getData() {
      let that = this
      let data = {
        now_page: that.pageNum,
        row_num: that.size,
        open_id: localStorage.getItem('openid'),
        teb_type: that.level2 === '推荐' ? '' : that.level2,
        file_type: that.level1
      }
      this.$fetchPost(URL.getHomeArticle.url, data).then((res) => {
        Toast.clear()
        //   this.list = res.data.data.url
        let list = res.data; //请求返回当页的列表
        that.refreshing = false;
        that.loading = false;
        that.total = res.data.total;
        if (list == null || list.length === 0) {
          // 加载结束
          that.finished = true;
          that.dataList=list
          return;
        }
        // 将新数据与老数据进行合并
        if (that.pageNum > 0) {
          that.dataList = [...that.dataList, ...list]
        } else {
          that.dataList = list
        }
        //如果列表数据条数>=总条数，不再触发滚动加载
        if (that.size != list.length) {
          that.finished = true;
        }
        //说明可能还有下一页
        if (that.size == list.length) {
          that.pageNum++;
        }
      });
    },
    onRefresh() {
      let that = this
      // (this.refreshing);
      that.finished = false;
      that.pageNum = 0
      that.loading = true;
      that.getData();
    },
    onLoad() {
      this.getData();
    },
    seeImg(ele, e) {
      this.$router.push({ path: '/graphicDetails', query: { articleId: ele.artcId } })
    },
    goToVideo(type, indexOrActId) {
      //跳转到视频页面
      let nowpage = 0
      let index = 0

      if (type === 'inner') {
        this.$router.push({
          name: "video",
          query: {
            articleId: indexOrActId
          }
        })
      } else {
        if (type === 'more') {
          nowpage = 3
          index = 0
        } else if (type === 'third') {
          nowpage = Math.ceil((indexOrActId + 1) / 5)
          index = indexOrActId % 5
        }
        this.$router.push({
          name: "video",
          query: {
            now_page: nowpage,
            teb_type: this.artile_type === '推荐' ? '' : this.artile_type,
            currentIndex: index
          }
        })
      }
    },
    goToDetails(id, imgUrl) {
      this.$router.push({
        path: "/articleDetails",
        query: {
          articleId: id,
          picUrl: imgUrl,
          openId: sessionStorage.getItem("openId"),
          canBack: "y",
          showLongBtn: 'n'
        }
      })
    },
  },
}
</script>

<style lang="less" scoped>
.home-class-style{
  background: #fff;
}
.home-swipe {
  width: 375px;
  height: 134px;
  img {
    width: 375px;
    height: 134px;
  }
}
.home-nav2-bg{
  width: 375px;
  height: 39px;
  background: url('./img/ul_bg.png') no-repeat 100%;
  background-size: 100% 100%;
  overflow: hidden;
  .home-nav2 {
      width: 345px;
     overflow-x: scroll;
         margin: 8px auto auto auto;
     display: flex;
     font-size: 11px;
     justify-content: space-between;
     ul {
       width: 345px;
       overflow-x: scroll;
     }
     .svg-icon {
       width: 13.5px;
       height: 2px;
       display: block;
       margin-left: 5.5px;
       margin-top: 2.5px;
     }
     .li-style2 {
       width: 24.5px;
       font-size: 12px;
       font-family: PingFang SC;
       color: #333333;
       font-weight: Regular;
     }
     .li-check-style2 {
       font-weight: bold;
       color: #fc6e09;
     }
   }
}
.home-article-nav {
  width: 345px;
  margin: 10px auto 0 auto;
  list-style: none;
  ul {
    margin-top: 22.5px;
    display: flex;
    font-size: 11px;
    justify-content: space-between;
  }
  .li-style {
    width: 72.5px;
    height: 22.5px;
    line-height: 22.5px;
    text-align: center;
    background: url("./img/home_bg3_1.png") no-repeat 100%;
    background-size: 100% 100%;
    font-size: 11px;
    font-family: PingFang SC;
    font-weight: Medium;
    color: #333333;
  }
  .li-check-style {
    background: url("./img/home_bg3.png") no-repeat 100%;
    background-size: 100% 100%;
    color: #fc6e09;
  }
  .header-search {
    width: 346px;
    height: 39px;
    line-height: 39px;
    background: url('./img/search.png') no-repeat 100%;
    background-size: 100% 100% ;
    .search-pla{
      padding-left: 15.5px;
      font-family: PingFang SC;
      font-weight: Regular;
      font-size: 10px;
      color: #CCCCCC;
    }
  }
}
.home-product {
  width: 375px;
  height: 243px;
  margin-top: 15px;
  padding-bottom: 18.5px;
  margin-bottom: 10px;
  // background: #fff;
  overflow: hidden;
  .home-pro-title {
    width: 345px;
    margin: 10px auto 0 auto;
    display: flex;
    justify-content: space-between;
  }
  .pro-title-left {
    display: flex;
    align-items: center;
    .svg-icon {
      width: 2px;
      height: 13px;
    }
    span {
      padding-left: 14px;
      font-size: 15px;
      font-weight: Bold;
      font-family: "PingFang SC";
      color: #333333;
    }
  }
  .pro-title-right {
    display: flex;
    align-items: center;
    span {
      display: flex;
      padding-right: 7px;
      font-size: 13px;
      font-weight: Regular;
      font-family: PingFang SC;
      color: #666666;
    }
    .svg-icon {
      width: 4.73px;
      height: 5.4px;
    }
  }
  .home-pro-img {
    width: 345px;
    margin: 11.5px auto 0 auto;
    .van-swipe {
      margin-top: 16px;
    }
    /deep/ .van-tabs__nav--card .van-tab {
      //   border: 0;
      border-right: 0.5px solid #ededed;
    }
    /deep/ .van-tabs__nav--card .van-tab:last-child {
      //   border: 0;
      border-right: 0;
    }
    /deep/ .van-tabs__nav--card {
      width: 100%;
      padding: 0;
      margin: 0;
      border: 0;
    }
    /deep/.van-tabs__wrap {
      height: 33px;
    }
    /deep/.van-tabs__nav--card .van-tab.van-tab--active {
      font-size: 14px;
      font-weight: bold;
      font-family: PingFang SC;
      color: #333333;
      background: url("./img/home_bg1.png") no-repeat 100%;
      background-size: 100% 100%;
      //   border: 1px solid;
      width: 115px;
      height: 33px;
    }
    /deep/.van-tabs__nav--card .van-tab {
      font-size: 14px;
      font-weight: Regular;
      font-family: PingFang SC;
      color: #333333;
      background: url("./img/home_bg2.png") no-repeat;
      background-size: 100% 100%;
      //   border: 1px solid;
      width: 115px;
      height: 33px;
    }
  }
  //   .van-swipe-item:not(:first-child){
  //       margin-left: 10px;
  //   }
}
.home-article {
  height: auto;
  .home-data-list {
    width: 345px;
    margin: 16.5px auto 0 auto;
    .home-list-sty:not(:first-child) {
      margin-top: 28px;
    }
    .home-list-sty {
      width: 100%;
      display: flex;
      .list-left {
        width: 95px;
        height: 57px;
        img{
          width: 100%;
          height: 100%;
        }
      }
      .list-right {
        width: calc(345px - 110px);
        margin-left: 15.5px;
      }
    }
    .list-r-tit {
      height: 27px;
      line-height: 12.5px;
      display: flex;
      align-items: flex-start;
      span {
        display: block;
        width: 197px;
        height: 26px;
        margin-left: 8px;
        overflow: hidden;
        font-size: 10.5px;
        font-weight: Medium;
        font-family: PingFang SC;
        color: #333333;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
      }
      .svg-icon {
        width: 27.5px;
        height: 17px;
      }
    }
    .list-r-foot {
      span {
        font-size: 9px;
        font-weight: Regular;
        font-family: PingFang SC;
        color: #999999;
      }
    }
    .list-r-foot span:last-child {
      padding-left: 5px;
    }
    .list-igm-foot {
      display: flex;
    }
    .home-imgList-sty {
      width: 100%;
      margin: 9px auto 9px auto;
      .home-isImg {
        display: flex;
        flex-wrap: wrap;
      }
      .home-img-size {
        width: 100%;
      }
      .home-img-size2 {
        width: 110px;
        height: 64px;
        margin-top: 5px;
      }
      .home-img-size2:nth-child(n) {
        margin-right: 7.5px;
      }
      .home-img-size2:nth-child(3n) {
        margin: 0;
      }
      .home-img-size4 {
        width: 40%;
        margin-right: 7.5px;
      }
    }
  }
}
.article_add {
  position: fixed;
  bottom: 37px;
  right: 13.5px;
  .svg-icon {
    width: 54.64px;
    height: 54.64px;
  }
}
</style>